// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../components/DefaultFields/DefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./AmountSelection.fulfillment";
import CheckboxWithName from "../../components/CheckboxWithName/CheckboxWithName";
import OptionsList from "../../components/OptionsList/OptionsList";
import EditableField from "../../components/EditableField/EditableField";
import NumberField from "../../components/NumberField/NumberField";
import * as CobHelpers from "../../Cob.helpers";

import swishLogo from "@assets/img/swish-logo.svg";
import swish100 from "@assets/img/swish-demo-100.png";
import swish500 from "@assets/img/swish-demo-500.png";
import swishChoose from "@assets/img/swish-demo-choose.png";


export default class AmountSelection extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		const checkboxMonthlyText = (state.fields.checkbox_autogiro_single.checked) ? "Jag vill även bli månadsgivare" : "Jag vill bli månadsgivare";

		let amountMonthly = 0;
		if (state.fields.checkbox_autogiro_monthly.checked) {
			if (state.fields.customer_autogiro_monthly_amount.options[0].checked) {
				amountMonthly = state.fields.customer_autogiro_monthly_amount.options[0].value;
			}
			else if (state.fields.customer_autogiro_monthly_amount.options[1].checked) {
				amountMonthly = state.fields.customer_autogiro_monthly_amount.options[1].value;
			}
			else if (state.fields.customer_autogiro_monthly_amount.options[2].checked) {
				amountMonthly = state.fields.customer_autogiro_monthly_amount_other;
			}
		}

		let amountSingle = 0;
		if (state.fields.checkbox_autogiro_single.checked) {
			if (state.fields.customer_autogiro_single_amount.options[0].checked) {
				amountSingle = state.fields.customer_autogiro_single_amount.options[0].value;
			}
			else if (state.fields.customer_autogiro_single_amount.options[1].checked) {
				amountSingle = state.fields.customer_autogiro_single_amount.options[1].value;
			}
			else if (state.fields.customer_autogiro_single_amount.options[2].checked) {
				amountSingle = state.fields.customer_autogiro_single_amount_other;
			}
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<CheckboxWithName
						style={{marginTop: "10px"}}
						label="Jag vill skänka ett engångsbelopp"
						name="checkbox_autogiro_single"
						value={(state.fields.checkbox_autogiro_single.checked) ? "yes" : "no"}
						checked={state.fields.checkbox_autogiro_single.checked}
						onChange={this._onCheckboxChange}
					/>

					{state.fields.checkbox_autogiro_single.checked && (
						<React.Fragment>
							<div className={"amount-options"}>
								<OptionsList
									type="radio"
									orientation="horizontal"
									name="customer_autogiro_single_amount"
									options={state.fields.customer_autogiro_single_amount.options}
									onChange={this._onOptionsListChange}
								/>

								{state.fields.customer_autogiro_single_amount.options[2].checked && (
									<div style={{margin: "20px 0 0 0", display: "block", maxWidth: "200px"}}>
										<strong style={{margin: "0 0 15px 0", display: "block"}}>Ange ett
											belopp</strong>
										<EditableField
											Component={NumberField}
											name="customer_autogiro_single_amount_other"
											label="Valfritt belopp"
											value={state.fields.customer_autogiro_single_amount_other}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
											unit={"kr"}
										/>
									</div>
								)}

								<input type={"hidden"} name={"customer_autogiro_amount_onetime"}
									   value={amountSingle + " kr"}/>
							</div>

							{(
								state.fields.customer_autogiro_single_amount.options[0].checked ||
								state.fields.customer_autogiro_single_amount.options[1].checked ||
								state.fields.customer_autogiro_single_amount.options[2].checked
							) && !state.showSwish && (
								<span className="link" onClick={this._showSwish}>Klicka här för att göra engångsöverföringen direkt med Swish</span>
							)}

							{(
								state.fields.customer_autogiro_single_amount.options[0].checked ||
								state.fields.customer_autogiro_single_amount.options[1].checked ||
								state.fields.customer_autogiro_single_amount.options[2].checked
							) && state.showSwish && (
								<div className={"pay-by-swish"}>
									<img src={swishLogo} className={"logo"} alt={"Logo: Swish"}/>

									<div className={"inner"}>

										{state.fields.customer_autogiro_single_amount.options[0].checked && (
											<React.Fragment>
												<img src={swish100} alt={"Swisha 100 kr"} title={"Swisha 100 kr"}/>
												<strong>Scanna koden ovan i din Swishapp och skänk 100 kr</strong>
											</React.Fragment>
										)}

										{state.fields.customer_autogiro_single_amount.options[1].checked && (
											<React.Fragment>
												<img src={swish500} alt={"Swisha 500 kr"} title={"Swisha 500 kr"}/>
												<strong>Scanna koden ovan i din Swishapp och skänk 500 kr</strong>
											</React.Fragment>
										)}

										{state.fields.customer_autogiro_single_amount.options[2].checked && (
											<React.Fragment>
												<img src={swishChoose} alt={"Swisha valfritt belopp"}
													 title={"Swisha valfritt belopp"}/>
												<strong>
													Scanna koden ovan i din Swishapp och fyll i beloppet att skänka
												</strong>
											</React.Fragment>
										)}
									</div>
								</div>
							)}
						</React.Fragment>
					)}

					<CheckboxWithName
						style={{marginTop: "20px"}}
						label={checkboxMonthlyText}
						name="checkbox_autogiro_monthly"
						value={(state.fields.checkbox_autogiro_monthly.checked) ? "yes" : "no"}
						checked={state.fields.checkbox_autogiro_monthly.checked}
						onChange={this._onCheckboxChange}
					/>

					{state.fields.checkbox_autogiro_monthly.checked && (
						<div className={"amount-options"}>
							<OptionsList
								type="radio"
								orientation="horizontal"
								name="customer_autogiro_monthly_amount"
								options={state.fields.customer_autogiro_monthly_amount.options}
								onChange={this._onOptionsListChange}
							/>

							{state.fields.customer_autogiro_monthly_amount.options[2].checked && (
								<div style={{margin: "20px 0 0 0", display: "block", maxWidth: "200px"}}>
									<strong style={{margin: "0 0 15px 0", display: "block"}}>Ange ett belopp</strong>
									<EditableField
										Component={NumberField}
										name="customer_autogiro_monthly_amount_other"
										label="Valfritt belopp"
										value={state.fields.customer_autogiro_monthly_amount_other}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										unit={"kr"}
									/>
								</div>
							)}

							<input type={"hidden"} name={"radio_autogiro_recurring"} value={"monthly"}/>
							<input type={"hidden"} name={"customer_autogiro_amount_recurring"}
								   value={amountMonthly + " kr"}/>
						</div>
					)}

				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_showSwish = () => {
		this.setState({showSwish: true});
	};
}


// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"checkbox_autogiro_single",
		"checkbox_autogiro_monthly",
		"customer_autogiro_single_amount",
		"customer_autogiro_monthly_amount",
		"customer_autogiro_single_amount_other",
		"customer_autogiro_monthly_amount_other",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	return {
		showSwish: false,
		fields: {
			customer_autogiro_single_amount_other: "",
			customer_autogiro_monthly_amount_other: "",

			checkbox_autogiro_single: {
				checked: false
			},

			checkbox_autogiro_monthly: {
				checked: false
			},

			customer_autogiro_single_amount: {
				options: [
					{label: "100 kr", value: "100", checked: false},
					{label: "500 kr", value: "500", checked: false},
					{label: "Valfritt", value: "other", checked: false}
				]
			},

			customer_autogiro_monthly_amount: {
				options: [
					{label: "150 kr", value: "150", checked: false},
					{label: "200 kr", value: "200", checked: false},
					{label: "Valfritt", value: "other", checked: false}
				]
			},
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/AmountSelection/AmountSelection.js